import {useState} from "react";
import {uuidv4} from "../services/uuid"
import {Modal, Button} from "react-bootstrap"
import {getRandomNumber} from "../services/api";

export function QuickDraw() {
    const [picked, setPicked] = useState("")
    
    const draw = (num) => {
        //let random = Math.floor(Math.random() * choices.length)
        setPicked("Deciding")
        //setPicked(choices[random].name)
        
        getRandomNumber(num)
            .then(result => {
                console.log("Da result ", result)
                if (result.number === 1) {
                    setPicked("Yes")
                } else {
                    setPicked("No")
                }
            })
            .catch(ex => {
                console.log("Error getting random ", ex);
            })
    }
    
    return (
        <>
            <div className="mt-3">
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(2)}>2</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(3)}>3</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(4)}>4</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(5)}>5</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(6)}>6</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(7)}>7</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(8)}>8</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(9)}>9</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(10)}>10</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(11)}>11</button>
                <button type="button" className="ms-2 btn btn-primary" onClick={() => draw(12)}>12</button>
            </div>
            <div className="mt-3">
                {picked.length > 0 && <span className={"ms-3"}>Winning Choice: {picked}</span>}
            </div>
        </>
            
    )
}